import React from 'react';
import Grid from "@material-ui/core/Grid";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {getDate} from "../../actions/calcul/getDate";
import {getRecipeById} from "../../actions/getFirestoreData/getRecipeById";
import {removeFavorite} from "../../actions/updateFirestoreData/userData/removeFavorite";
import {addFavorite} from "../../actions/updateFirestoreData/userData/addFavorite";
import {numAverage} from "../../actions/calcul/average";
import {RateIcon} from "../../components/mui/RateIcon";
import ExpansionPan from "../../components/mui/ExpansionPan";
import RecipeImage from "../../components/recipePage/RecipeImage";
import LikeMenu from "../../components/recipePage/Likes";
import {LinearProgress, Typography, Card, CardHeader, CardContent, Divider, IconButton} from "@material-ui/core";
import FavoritePic from "@material-ui/icons/Favorite";
import FavoriteBorderIcon from "@material-ui/icons/FavoriteBorder";
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import ThumbDownAltIcon from '@material-ui/icons/ThumbDownAlt';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';


/**
 * This class will display a page about one recipe, identify by the recipe id
 */
class RecipePage extends React.Component {

    state = {
        recipes: [],
        isLoading: true,
        limitComment: 3
    }

    componentDidMount = async () => {
        let path = this.props.location.pathname.split("/")
        let id = path[path.length - 1]
        let recipe = await this.props.getRecipeById(parseInt(id));
        let isFavorite = this.props.auth ? this.props.auth.favoris.includes(parseInt(id)) : false;
        this.setState({
            recipe: recipe,
            isFavorite,
            isLoading: false,
            //isPdfDisplayed : false
        })
    };


    addToFavorite = async (e) => {
        e.preventDefault()
        await this.props.addFavorite({recipe: this.state.recipe, userPseudo: this.props.auth.pseudo})
        this.setState({
            isFavorite: !this.state.isFavorite
        })
    }

    removeToFavorite = async (e) => {
        e.preventDefault()
        await this.props.removeFavorite(this.state.recipe, this.props.auth)
        this.setState({
            isFavorite: !this.state.isFavorite
        })
    }

    moreComment = () => {
        let limit = this.state.limitComment + 2;
        if (limit >= this.state.recipe.comments.length) {
            limit = this.state.recipe.comments.length
        }
        this.setState({limitComment: limit})
    }
    lessComment = () => {
        let limit = this.state.limitComment - 2;
        if (limit <= 0) {
            limit = 1
        }
        this.setState({limitComment: limit})
    }

    render() {
        //const classes = useStyles();
        const {recipe, isFavorite, classes, isLoading} = this.state
        if (isLoading) {
            return (<LinearProgress/>)
        }
        if (recipe) {
            let ingredientsName = Object.keys(recipe.ingredients_quantity)
            let ingredientsQuantity = Object.values(recipe.ingredients_quantity)
            let recipeIngredients = []
            for (let i = 0; i < ingredientsName.length; i++) {
                recipeIngredients.push({name: ingredientsName[i], quantity: ingredientsQuantity[i]})
            }
            let likesSum = 0;
            if (recipe.likes) {
                for (let j = 0; j < recipe.likes.length; j++) {
                    likesSum += recipe.likes[j].value;
                }
            }

            return (
                <>
                    <Grid container direction="column" justify="center" alignItems="center">
                        <Grid container direction="column" justify="center" alignItems="center">
                            <Card style={{width: "60%"}}>
                                <RecipeImage recipe={recipe} recipeIngredients={recipeIngredients}
                                             displayAction={this.props.auth ? true : false}/>
                                <Grid container direction="row" justify="space-around" alignItems="center"
                                      style={{marginTop: 5}}>
                                    <Grid item> <Typography variant='h3' style={{
                                        fontSize: "16px",
                                        fontFamily: "Georgia, Times, Helvetica, Verdana"
                                    }}>{recipe.name}</Typography></Grid>
                                    <Grid item><Typography variant='h6'
                                                           style={{fontSize: "12px"}}>{recipe.timming}
                                    </Typography></Grid>
                                </Grid>
                                <Divider style={{marginTop: 15, background: '#ff6f61'}}/>
                                <Typography variant='h5' align='center'
                                            style={{color: '#ff6f61'}}>Ingrédients</Typography>
                                <Divider style={{marginTop: 5, marginBottom: 5, background: '#ff6f61'}}/>
                                <ul>
                                    {
                                        recipeIngredients ?
                                            recipeIngredients.map((ingredient, index2) =>
                                                <li><Typography
                                                    style={{margin: 10}} key={index2}
                                                    paragraph
                                                >
                                                    {ingredient.quantity} {ingredient.name}
                                                </Typography>
                                                </li>
                                            )

                                            : ""
                                    }
                                </ul>
                                <Divider style={{marginTop: 15, background: '#ff6f61'}}/>
                                <Typography variant='h5' align='center'
                                            style={{color: '#ff6f61'}}> Préparation </Typography>
                                <Divider style={{marginTop: 5, marginBottom: 5, background: '#ff6f61'}}/>

                                {
                                    recipe.steps_preparation ?
                                        recipe.steps_preparation.map((etape, index2) =>
                                            <Typography style={{margin: 10}} key={index2}
                                                        paragraph>Etape {index2} : {etape}</Typography>)
                                        : ""
                                }

                                {
                                    recipe.comments ?
                                        <ExpansionPan
                                            content={<Grid>
                                                {recipe.comments.slice(0, this.state.limitComment) ? recipe.comments.slice(0, this.state.limitComment).map((comment, index3) =>
                                                    <Card key={index3}
                                                          style={{backgroundColor: "rgb(200, 200, 200)", margin: 10}}>
                                                        <CardHeader
                                                            title={comment.user}
                                                            subheader={getDate(comment.date.seconds)}
                                                        />
                                                        <CardContent>
                                                            <Typography paragraph> {comment.text} </Typography>
                                                        </CardContent>
                                                    </Card>
                                                ) : ""}
                                                <IconButton onClick={this.moreComment}><AddIcon/></IconButton>
                                                <IconButton onClick={this.lessComment}><RemoveIcon/></IconButton>
                                            </Grid>
                                            }
                                            title="Commentaires"
                                        />
                                        : ""
                                }

                                <Grid container direction="row" justify="space-between" alignItems="center"
                                      style={{marginTop: 5}}>
                                    <Grid>
                                        {this.props.auth ?
                                            <IconButton type='button'
                                                        onClick={isFavorite ? this.removeToFavorite : this.addToFavorite}>
                                                {isFavorite ? <FavoritePic style={{color: '#f44336'}}/> :
                                                    <FavoriteBorderIcon/>}
                                            </IconButton>

                                            : null
                                        }
                                    </Grid>
                                    <Grid item style={{color: '#f44336'}}>
                                        <RateIcon rateValue={recipe.ratings ? numAverage(recipe.ratings) : 0}/>
                                    </Grid>
                                </Grid>

                                <Grid container direction="row" justify="space-between" alignItems="center"
                                      style={{marginTop: 5}}>
                                    <Grid>
                                        <LikeMenu recipeName={recipe.name}/>
                                    </Grid>
                                    <Grid>
                                        {likesSum >= 0 ? <ThumbUpIcon style={{color: '#2196f3'}}/> :
                                            <ThumbDownAltIcon style={{color: '#f44336'}}/>}
                                        {likesSum}
                                    </Grid>
                                </Grid>

                            </Card>
                        </Grid>

                        {/*<Button onClick={this.showPdf}>apperçu du pdf</Button>

                                    { this.state.isPdfDisplayed ? <PDFViewer><PdfDocument steps={recipe.steps_preparation} image={recipe.image} title={recipe.name} ingredients={recipeIngredients}/></PDFViewer> : "" }

                                    <PDFDownloadLink document={<PdfDocument steps={recipe.steps_preparation} image={recipe.image} title={recipe.name} ingredients={recipeIngredients}/>}
                                    fileName={recipe.name+".pdf"}>
                                    {({ blob, url, loading, error }) => (loading ? 'Loading document...' : <Button><GetApp/></Button>)}
                                    </PDFDownloadLink>*/}

                    </Grid>
                </>
            )
        }
    }
}


const mapStateToProps = ({auth}) => {
    return {auth}
}

export default withRouter(connect(
    mapStateToProps,
    {numAverage, getRecipeById, getDate, removeFavorite, addFavorite}
)(RecipePage))
